import { darken } from 'polished';
import { DEFAULT_QUALITY_MINIMAP_GRADIENT_STOPS } from '../consts';
import { interpolateMinimapGradientColor } from './interpolate-minimap-gradient-color';

/**
 * Maps a normalized quality / success rate in [0, 1] to a CSS color using the default stream-quality
 * gradient (offline → poor-quality → online). Values are clamped the same way as the minimap.
 */
export function qualityReportColor(
  rate0to1: number,
  stops = DEFAULT_QUALITY_MINIMAP_GRADIENT_STOPS,
): string {
  return interpolateMinimapGradientColor(rate0to1, stops);
}

export function qualityReportColorForText(
  rate0to1: number,
  stops = DEFAULT_QUALITY_MINIMAP_GRADIENT_STOPS,
): string {
  return darken(0.05, qualityReportColor(rate0to1, stops));
}
